export default __webpack_public_path__ + "static/media/p-pomodoro-clock.f68c755f.jpg";